import React from 'react';
import { Grid, Typography } from '@mui/material';
import { SummaryStatusBadge } from './summaryStatusBadge.dumb';
import { SummaryNormativeBadge } from './summaryNormativeBadge.dumb';
import { SummaryLabel } from './summaryLabel.dumb';

interface SummaryRowProps {
  module: any; // Replace 'any' with specific type
  config: {
    key: string;
    headingKey: string;
  };
  assessmentSummaryHelper: any; // Replace 'any' with  specific type
  translate: (key: string) => string;
}

const SummaryRow: React.FC<SummaryRowProps> = ({
  module,
  config,
  assessmentSummaryHelper,
  translate,
}) => {
  const { key, headingKey } = config;
  const moduleData = module[key];
  const isNormativeFunction = assessmentSummaryHelper[`${key}IsNormative`];

  return (
    <Grid item container justifyContent="space-between">
      <Grid item xs={3}>
        <SummaryStatusBadge
          module={moduleData}
          skipped={assessmentSummaryHelper?.moduleSkipped(moduleData)}
        />
      </Grid>
      <Grid item xs={3}>
        <Typography>{translate(headingKey)}</Typography>
      </Grid>
      <Grid item xs={3}>
        <SummaryNormativeBadge
          notApplicable={!moduleData}
          isNormative={
            typeof isNormativeFunction === 'function'
              ? isNormativeFunction(moduleData)
              : false
          }
          skipped={assessmentSummaryHelper?.moduleSkipped(moduleData)}
        />
      </Grid>
      <Grid item xs={3}>
        <SummaryLabel
          summaryLabelText={assessmentSummaryHelper?.comments(
            moduleData,
            moduleData?.[`${key}ClinicalNotes`],
          )}
        />
      </Grid>
    </Grid>
  );
};

export { SummaryRow };
